import { render, staticRenderFns } from "./SignWidget.vue?vue&type=template&id=d8c47e6a&"
import script from "./SignWidget.vue?vue&type=script&lang=js&"
export * from "./SignWidget.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports